import { Card, FormControlLabel, Switch } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDInput from "@/components/atoms/MDInput";
import MDTypography from "@/components/atoms/MDTypography";
import {
  getCancelOptionOptions,
  getConsentExpirationOptions,
} from "@/components/templates/CustomerForm/constants";
import { CustomerConfigurationFormData } from "@/components/templates/CustomerForm/types";
import { ConfigurationTabMessages } from "@/messages/customer/configuration-tab.messages";

type Props = {
  messages: ConfigurationTabMessages;
};

function ConsentLGPDCard({ messages }: Props) {
  const { values, errors, setFieldValue } = useFormikContext<CustomerConfigurationFormData>();

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox p={3}>
        <MDBox display="flex" justifyContent="space-between">
          <MDTypography variant="h5" fontWeight="bold">
            {messages.consentSection}
          </MDTypography>

          <FormControlLabel
            control={
              <Switch
                checked={values.consentRequest}
                onChange={(_, checked) => setFieldValue("consentRequest", checked)}
              />
            }
            label={messages.consentRequestLabel}
          />
        </MDBox>
        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Autocomplete
                fullWidth
                options={getConsentExpirationOptions(messages)}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                value={
                  getConsentExpirationOptions(messages).find(
                    (option) => option.value === values.consentExpiration
                  ) || null
                }
                onChange={(_, newValue) => {
                  setFieldValue("consentExpiration", newValue ? newValue.value : "");
                }}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    label={messages.consentExpirationLabel}
                    variant="standard"
                    error={!!errors.consentExpiration}
                    helperText={errors.consentExpiration}
                  />
                )}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <Autocomplete
                fullWidth
                options={getCancelOptionOptions(messages)}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                value={
                  getCancelOptionOptions(messages).find(
                    (option) => option.value === values.consentCancel
                  ) || null
                }
                onChange={(_, newValue) => {
                  setFieldValue("consentCancel", newValue ? newValue.value : "");
                }}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    label={messages.cancelOptionLabel}
                    variant="standard"
                    error={!!errors.consentCancel}
                    helperText={errors.consentCancel}
                  />
                )}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ConsentLGPDCard;
